import { Barbell, Lightning, Heartbeat, ChartLineDown, Flag } from "@phosphor-icons/react";

/**
 * Primary fitness goal the user picks during onboarding (and can change in Settings).
 * Stored as a slug on the profile (`primary_goal`).
 *
 *  - `label` is shown in cards.
 *  - `headline` is a one-liner shown under the label.
 *  - `aiFocus` is fed into the AI plan generator's `goal_focus` field so the
 *    generated program matches the user's intent without them re-typing.
 */
export const PRIMARY_GOALS = [
  {
    value: "gain_mass",
    label: "Gain Mass",
    headline: "Build size and visible muscle",
    aiFocus: "Hypertrophy / Mass",
    icon: Barbell,
  },
  {
    value: "gain_strength",
    label: "Gain Strength",
    headline: "Lift heavier, push harder",
    aiFocus: "Strength",
    icon: Lightning,
  },
  {
    value: "gain_endurance",
    label: "Gain Endurance",
    headline: "Last longer, recover faster",
    aiFocus: "Endurance",
    icon: Heartbeat,
  },
  {
    value: "lose_weight",
    label: "Lose Weight",
    headline: "Drop body fat, stay strong",
    aiFocus: "Fat Loss",
    icon: ChartLineDown,
  },
  {
    value: "general_fitness",
    label: "Increase Fitness",
    headline: "Feel good, move well, stay healthy",
    aiFocus: "General Fitness",
    icon: Flag,
  },
];

export const findGoal = (value) => PRIMARY_GOALS.find((g) => g.value === value);
